<template>
	<div class="verificationCode">
		<!-- 操作验证 -->
		<el-dialog title="操作验证" :visible.sync="visible" width="600px" @close="close">
			<div class="hint">
				<ig-icon class="icon" name="remind1"></ig-icon>
				<p>当前操作需要主管授权，请选择主管后，向主管请求短信验证码</p>
			</div>
			<el-form ref="form" label-width="80px" size="small">
				<el-form-item label="选择主管">
					<el-select v-model="selectcontent" placeholder="请选择主管" @change="selectChange">
						<el-option
							v-for="item in options"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="code" label="验证码">
					<el-row>
						<el-col :span="15">
							<el-input v-model="verificationCode"></el-input>
						</el-col>
						<el-col :span="6" style="margin-left: 28px">
							<el-button type="primary" @click="getVerificationCode" :disabled="disabled">
								{{ verificationText }}
							</el-button>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" @click="confirm">确认操作</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import customer from '@/backend/services/account/customer';

export default {
	name: 'verificationCode',
	data() {
		return {
			// 操作验证弹窗属性
			visible: false,
			options: [],
			selectcontent: '',
			verificationText: '获取验证码',
			verificationCode: '',
			btnLoading: false,
			disabled: false,
			timeId: '',
			callback: null,
		};
	},
	methods: {
		async show() {
			const self = this;
			await this.getLeadersList();
			this.$nextTick(() => {
				self.visible = true;
			});
			return new Promise(reslove => {
				self.callback = reslove;
			});
		},
		// 获取人员列表
		async getLeadersList() {
			let res = await customer.leaders();
			if (res.data) {
				this.options = res.data;
				this.visible = true;
			}
		},
		// 主管选择
		selectChange(val) {
			if (val) {
				this.disabled = false;
				this.verificationText = '获取验证码';
				clearInterval(this.timeId);
			}
		},
		// 获取验证码
		async getVerificationCode() {
			let { selectcontent } = this;
			if (!selectcontent) {
				this.$message({
					message: '请选择主管',
				});
				return false;
			}

			let time = 59;
			this.disabled = true;
			this.timeId = setInterval(() => {
				this.verificationText = `(${time})重新获取`;
				if (time === 0) {
					this.verificationText = '获取验证码';
					clearInterval(this.timeId);
					this.disabled = false;
				}
				time--;
			}, 1000);

			// 请求验证码

			customer.verificationcode(selectcontent);
		},
		// 重置数据
		rest() {
			this.selectcontent = '';
			this.verificationCode = '';
		},
		// 取消操作
		close() {
			this.callback &&
				this.callback({
					cancel: true,
				});
			this.rest();
			this.visible = false;
		},
		// 确认操作
		confirm() {
			let { verificationCode, selectcontent } = this;
			if (!verificationCode) {
				this.$message({
					message: '请输入验证码',
				});
				return;
			}

			this.callback &&
				this.callback({
					userId: selectcontent,
					code: verificationCode,
					cancel: false,
				});
			this.rest();
			this.visible = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.verificationCode {
	.el-form {
		padding: 0 60px;

		.el-select--small {
			width: 100%;
		}
	}

	.hint {
		width: 100%;
		font-size: 14px;
		color: #333;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 15px 0 40px;

		.icon {
			color: #ffce3d;
			margin-right: 5px;
		}
	}

	.dialog-footer {
		width: 40%;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
</style>
